export default __webpack_public_path__ + "static/media/blauwe_vlag.78ff6ffd.svg";